import { httpClient } from './http-client';

export const sendMail = async (formData) => {
  try {
    console.log(formData, 'formdatas');
    const response = await httpClient.post('api/send_email.php', formData);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
